<p-blockui [blocked]="isLoading">
  <p-progress-spinner></p-progress-spinner>
</p-blockui>

<div class="flex flex-col gap-6 pb-[10rem]">
  <div class="flex flex-row justify-between">
    <div class="">
      <h1 class="main-title">Lista de usuarios</h1>
      <p class="main-subtitle">
        Total de usuarios: {{ totalRecords }}
      </p>
    </div>

    <div class="flex flex-row gap-3">
      @if(UserRole.BUSSINESSMEN | notHasRole){
        <p-button severity="primary" type="button" (onClick)="onCreateUser()">
          <span>Crear usuario</span>
        </p-button>
      }
    </div>
  </div>

  <!-- Filtros -->
  <app-user-filter
    [businessGroupOptions]="businessGroupOptions"
    [loading]="isLoading"
    (filterChange)="handleFilterChange($event)"
    (clearFilters)="handleClearFilters()"
  />

  <!-- Tabla listado de usuarios -->
  <app-users-list
    [data]="filteredData"
    [totalRecords]="totalRecords"
    [sortBy]="sortBy"
    [sortOrder]="sortOrder"
    [first]="paginationState().first!"
    [rows]="paginationState().rows!"
    [loading]="isLoading"
    (pageChange)="onPageChange($event)"
    (toggleSort)="toggleSort($event)"
    (handleConfirmChangeStatus)="handleConfirmChangeStatus($event)"
    (handleEditUser)="onEditUser($event)"
  />

  <app-confirmation-dialog
    [(visible)]="showStatusChangeDialog"
    type="warning"
    title="Cambiar de estado"
    [message]="changeStatusMessage"
    [confirmButtonText]="changeStatusButton"
    cancelButtonText="Cancelar"
    (onConfirm)="confirmStatusChange()"
    (onCancel)="cancelStatusChange()">
  </app-confirmation-dialog>

  <p-toast />
</div>
